import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import APIs from "../../APIs";

const ServiceDetails = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState(null);
  useEffect(() => {
    const fetchService = async () => {
      setLoading(true);

      try {
        const res = await APIs.post(
          "service/getServiceById",
          { service_id: id },
          { headers: { "Content-Type": "application/json" } }
        );

        console.log("Service details data:", res.data);

        if (res.data && res.data.data) {
          const serviceData = res.data.data;

          // Map API keys to match your component
          setService({
            ...serviceData,
            features: serviceData.service_features || [],
            faqs: serviceData.service_faqs || [],
          });
        } else {
          setService(null);
        }
      } catch (err) {
        console.error("Error fetching service:", err);
        setService(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchService();
  }, [id]);
useEffect(() => {
        getAllServices();
    }, []);

    const getAllServices = async () => {

        try {
            const response = await APIs.get('service/getAllService', {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (response.data.status === "success") {
                setServices(response.data.data);
            }

        } catch (error) {
          
        }
    }
  if (loading) {
    return (
      <div className="page-content text-center py-5">
        <h4>Loading service details...</h4>
      </div>
    );
  }

  if (!service) {
    return (
      <div className="page-content text-center py-5">
        <p>No service found.</p>
        <Link to="/services" className="btn btn-outline-primary mt-3">
          ← Back to Services
        </Link>
      </div>
    );
  }
console.log("services",services);
  return (
    <div className="page-content">
      <section className="site-content service-details">
        <div className="container">
          <div className="row">
            {/* LEFT COLUMN */}
            <div className="col-md-12 col-xl-9 service-left-col">
              <div className="eagle-entry-content">
                <div className="eagle-service_content">
                  <div className="eagle-heading animation-style2">
                    <h3 className="eagle-title mb-3">
                      {service.service_name}
                    </h3>
                  </div>

                  <p className="eagle-firstletter">
                    {service.service_description ||
                      "No description available for this service."}
                  </p>

                  {/* IMAGE + FEATURES */}
                  <div className="service-wrap mt-4">
                    <div className="row">
                      <div className="col-md-12 col-xl-6">
                        <div className="service-single-img-first">
                          <img
                            src={service.service_image || "/images/default.jpg"}
                            alt={service.service_name}
                            className="img-fluid rounded"
                            style={{ border: "1px solid #ddd", borderRadius: "10px" }}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 col-xl-6">
                        <div className="service-wrapper">
                          <div className="eagle-heading">
                            <h3 className="eagle-title">Key Features:</h3>
                          </div>
                          {service.features?.length ? (
                            <ul className="list-group list-group-borderless">
                              {service.features.map((f, i) => (
                                <li className="list-group-item" key={i}>
                                  <span className="eagle-icon-list-text">{f.feature || f}</span>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p>No features listed.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* FAQ SECTION */}
                  <div className="service-contants mt-5">
                    <div className="eagle-heading animation-style2">
                      <h3 className="eagle-title mb-3">Frequently Asked Questions (FAQ)</h3>
                    </div>
                    <div className="accordion" id="accordionExample1">
                      {service.faqs?.length ? (
                        service.faqs.map((faq, index) => (
                          <div className="accordion-item" key={index}>
                            <h2 className="accordion-header" id={`heading${index}`}>
                              <button
                                className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${index}`}
                                aria-expanded={index === 0 ? "true" : "false"}
                                aria-controls={`collapse${index}`}
                              >
                                <span className="eagle-accordion-title">{faq.question}</span>
                              </button>
                            </h2>
                            <div
                              id={`collapse${index}`}
                              className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                              aria-labelledby={`heading${index}`}
                              data-bs-parent="#accordionExample1"
                            >
                              <div className="accordion-body">{faq.answer}</div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No FAQs available for this service.</p>
                      )}
                    </div>

                  
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDEBAR */}
            <div className="col-md-12 col-xl-3 service-right-col sidebar">
              <aside className="service-sidebar">
                <aside className="widget post-list">
                  <h2 className="widget-title">Other Services</h2>
                  <div className="all-post-list">
                    <ul>
                      {services?.length ? (
                        services.map((s) => (
                            <li key={s.service_id}>
                              <Link to={`/service-details/${s.service_id}`}>
                                {s.service_name}
                              </Link>
                            </li>
                          ))
                      ) : (
                        <li>No other services available.</li>
                      )}
                    </ul>
                  </div>
                </aside>
              </aside>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetails;
